import { render } from "./ChartCanvas.vue?vue&type=template&id=7edd5cbf&scoped=true"
import script from "./ChartCanvas.vue?vue&type=script&lang=js"
export * from "./ChartCanvas.vue?vue&type=script&lang=js"

import "./ChartCanvas.vue?vue&type=style&index=0&id=7edd5cbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edd5cbf"]])

export default __exports__